/**
 * operatorId — extract the current operator's user_id from the access
 * token in localStorage.
 *
 * Used by the per-surface dismiss-state localStorage key per sprint plan
 * §451: `dismissed:{operator_id}:{surface}:{pattern_id}`.
 *
 * No verification — the token is signed server-side; the frontend just
 * reads the payload claim. If the token is absent or malformed, falls
 * back to `'anonymous'` (single-operator cycle-102 scope: this still
 * keeps dismiss state functional for the local user).
 */

const ANONYMOUS = 'anonymous';

export function getCurrentOperatorId(): string {
  try {
    const token = localStorage.getItem('access_token');
    if (!token) return ANONYMOUS;
    const segments = token.split('.');
    if (segments.length !== 3) return ANONYMOUS;
    const payload = JSON.parse(decodeBase64Url(segments[1])) as Record<string, unknown>;
    const userId = payload.user_id ?? payload.sub;
    if (typeof userId === 'string' && userId.length > 0) return userId;
    return ANONYMOUS;
  } catch {
    return ANONYMOUS;
  }
}

function decodeBase64Url(input: string): string {
  let s = input.replace(/-/g, '+').replace(/_/g, '/');
  while (s.length % 4 !== 0) s += '=';
  // jsdom + browser both expose `atob`; throw if running outside either.
  return atob(s);
}
